import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
//import { Verification, SellingPoint } from '../verification'

@Component({
  selector: 'app-verification-form',
  templateUrl: './verification-form.component.html',
  styleUrls: ['./verification-form.component.less']
})
export class VerificationFormComponent implements OnInit {

  constructor(private fb: FormBuilder) { }
  productForm: FormGroup;

  ngOnInit(): void {
     /* Initiate the form structure */
     this.productForm = this.fb.group({
     // title: [],
      selling_points: this.fb.array([this.fb.group({point:'', abc:''})])
    })
  }

  get sellingPoints() {
    return this.productForm.get('selling_points') as FormArray;
  }

  addSellingPoint() {
    this.sellingPoints.push(this.fb.group({point:'', abc:''}));
  }

  deleteSellingPoint(index) {
    this.sellingPoints.removeAt(index);
  }

}
